import { Alert, Container, Paper, Stack, Typography } from '@mui/material';

export default function CookiePolicyPage() {
  return (
    <Container maxWidth="md" sx={{ pt: 16, pb: 8 }}>
      <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 4 }}>
        <Stack spacing={2}>
          <Typography variant="h3">Preferences de cookies</Typography>
          <Typography variant="body1" color="text.secondary">
            Jacana utilise des choix distincts pour la mesure d audience. Les cookies strictement necessaires au fonctionnement du site ne sont pas concernes par ce panneau.
          </Typography>
          <Alert severity="info" variant="outlined">
            Le consentement analytics est optionnel. Il peut etre refuse sans bloquer l acces aux reservations ou au compte.
          </Alert>
          <Typography variant="body1" color="text.secondary">
            Le projet initialise Firebase Analytics uniquement apres choix positif. Ce choix peut ensuite etre mis a jour dans la page Mes consentements pour les utilisateurs connectes.
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
}